import getAppName from '../utils/getAppName';
import { OverlayType } from './interface';
export const NAV_OVERLAY_CONFIG_MSG_ID = '__nav_config_msg_id';
export const DEFAULT_OVERLAY_DISPLAY_CONFIG = {
  shouldShowToolbar: false,
  shouldShowNav: false
};
export const DEFAULT_APP_OVERLAY_CONFIG = {
  appName: getAppName(),
  isInitialized: false,
  [OverlayType.MODAL]: {
    shouldShowToolbar: false,
    shouldShowNav: false
  }
};
export const SHOW_OVERLAY_WITH_TOOLBAR_AND_BANNERS_CLASS = 'show-overlay-with-toolbar-and-banners';
export const SHOW_OVERLAY_WITH_NAV_CLASS = 'show-overlay-with-nav';
export const SHOW_OVERLAY_WITHOUT_BANNERS_CLASS = 'show-overlay-without-banners';